// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/blog/NewPost.js
import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebase';
import { collection, doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './NewPost.css';

const NewPost = () => {
  const [title, setTitle] = useState('');
  const [slug, setSlug] = useState('');
  const [content, setContent] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [keywords, setKeywords] = useState('');
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');

  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '') // Eliminar caracteres no permitidos
      .replace(/\s+/g, '-') // Reemplazar espacios por guiones
      .replace(/-+/g, '-'); // Reemplazar múltiples guiones por uno solo
  };

  useEffect(() => {
    setSlug(generateSlug(title));
  }, [title]);

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = '';
      if (image) {
        const imageRef = ref(storage, `images/${slug}`);
        await uploadBytes(imageRef, image);
        imageUrl = await getDownloadURL(imageRef);
      }

      await setDoc(doc(db, 'posts', slug), {
        title,
        slug,
        content,
        metaDescription,
        keywords,
        imageUrl,
        createdAt: new Date()
      });
      setTitle('');
      setSlug('');
      setContent('');
      setMetaDescription('');
      setKeywords('');
      setImage(null);
      setImageUrl('');
      alert('Publicación creada con éxito');
    } catch (error) {
      console.error('Error al crear la publicación: ', error);
      alert('Error al crear la publicación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newpost-container">
      <h1 className="newpost-title">Crear Nueva Publicación</h1>
      <form onSubmit={handleSubmit} className="newpost-form">
        <div className="newpost-form-group">
          <label htmlFor="title">Título</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="newpost-form-group">
          <label htmlFor="slug">Slug</label>
          <input
            type="text"
            id="slug"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            required
          />
        </div>
        <div className="newpost-form-group">
          <label htmlFor="metaDescription">Meta Descripción</label>
          <textarea
            id="metaDescription"
            value={metaDescription}
            onChange={(e) => setMetaDescription(e.target.value)}
            required
          ></textarea>
        </div>
        <div className="newpost-form-group">
          <label htmlFor="keywords">Palabras Clave</label>
          <input
            type="text"
            id="keywords"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
            required
          />
        </div>
        <div className="newpost-form-group">
          <label htmlFor="content">Contenido</label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            className="content-textarea"
          ></textarea>
        </div>
        <div className="newpost-form-group">
          <label htmlFor="image">Imagen de Portada</label>
          <input
            type="file"
            id="image"
            onChange={handleImageChange}
          />
        </div>
        <button type="submit" className="newpost-submit" disabled={loading}>
          {loading ? 'Publicando...' : 'Publicar'}
        </button>
      </form>
    </div>
  );
};

export default NewPost;